import { Entity, Fields, Relations, Allow } from "remult";
import { ChatEntry } from "../chat-entry/entity";

@Entity("chat", {
    allowApiRead: Allow.authenticated,
    allowApiCrud: false
})
export class Chat {
    @Fields.string()
    id = "";

    @Fields.string({ dbName: "opportunity_id" })
    opportunityId = "";

    @Relations.toMany(() => ChatEntry, "chatId")
    entries: ChatEntry[] = [];
}
